import PaymodesFooter from './PaymodesFooter';

export default PaymodesFooter;
